import { NavigateFunction } from 'react-router-dom';
import { getPendingAssessment, clearPendingAssessment } from './assessmentStorage';
import { getPendingDownload, clearPendingDownload } from './benchmarkStorage';
import { ROUTES } from '@/config/routes';
import { toast } from 'sonner';

export const handlePostLoginActions = async (navigate: NavigateFunction): Promise<void> => {
  try {
    // Check for pending downloads first (higher priority)
    const pendingDownload = getPendingDownload();
    if (pendingDownload) {
      clearPendingDownload();
      
      // Add search param to indicate pending download
      const url = new URL(pendingDownload.returnUrl);
      url.searchParams.set('downloadAll', 'true');
      
      // Navigate to the return URL with download parameter
      navigate(url.pathname + url.search);
      toast.success('Redirecting to download...');
      return;
    }
    
    // Check for pending assessments
    const pendingAssessment = getPendingAssessment();
    if (pendingAssessment) {
      clearPendingAssessment();
      navigate(pendingAssessment.returnTo);
      toast.success('Redirecting to your assessment...');
      return;
    }
    
    // Check for stored redirect intent
    const storedRedirect = sessionStorage.getItem('auth_redirect_to');
    if (storedRedirect) {
      sessionStorage.removeItem('auth_redirect_to');
      navigate(storedRedirect, { replace: true });
      toast.success('Redirecting to your intended destination...');
      return;
    }
    
    // Default redirect if no pending actions - go to benchmarking (main feature)
    // This applies to both regular login and password reset completion
    navigate(ROUTES.PERMIT_BENCHMARKING.ROOT, { replace: true });
  } catch (error) {
    console.error('Error handling post-login actions:', error);
    // Fallback to default redirect
    navigate(ROUTES.PERMIT_BENCHMARKING.ROOT, { replace: true });
  }
}; 